import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
var appendScript = function() {
    var _ref = _async_to_generator(function(src) {
        var tag;
        return _ts_generator(this, function(_state) {
            if (document.querySelectorAll('script[src="'.concat(src, '"]')).length) {
                return [
                    2
                ];
            }
            tag = document.createElement("script");
            tag.src = src;
            tag.async = true;
            document.body.appendChild(tag);
            return [
                2
            ];
        });
    });
    return function appendScript(src) {
        return _ref.apply(this, arguments);
    };
}();
export default appendScript;
